export const theme = {
  black: "#000000",
  blackish: "#161616",
  lightblack: "#0E0D12",
  geryish: "#111111",
  white: "#FFFFFF",
  grey: "#F7F7F7",
  darkblue: "#0A1A2D",
  lightblue: "#008382",
  lightgreen: "#307361",
  green: "#1C473B",
  yellow: "#FFA300",
  lightyellow: "#FFAC46",
  yellowish: "#FAE47C",
  orange: "#FF3300",
  red: "#ED5F4B",
  darkred: "#E13100",
  blurryright:
    "linear-gradient(-90deg, #FFFFFF 33.73%, rgba(249, 249, 249, 0.890625) 56.49%, rgba(255, 255, 255, 0) 100%)",
  blurryleft:
    "linear-gradient(90deg, #FFFFFF 33.73%, rgba(249, 249, 249, 0.890625) 56.49%, rgba(255, 255, 255, 0) 100%)",
  
  // Font stacks with system font fallbacks to prevent layout shifts
  fonts: {
    sofia: "Sofia, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    ivy: "Ivy, Georgia, 'Times New Roman', Times, serif",
  },
  
  // Spacing scale for consistent layout dimensions
  spacing: {
    xs: "0.25rem",    // 4px
    sm: "0.5rem",     // 8px
    md: "0.75rem",    // 12px
    lg: "1rem",       // 16px
    xl: "1.25rem",    // 20px
    "2xl": "1.5rem",  // 24px
    "3xl": "1.75rem", // 28px
    "4xl": "2rem",    // 32px
    "5xl": "2.5rem",  // 40px
    "6xl": "3rem",    // 48px
    "7xl": "3.5rem",  // 56px
    "8xl": "4rem",    // 64px
    
    // Specific layout values (converted from magic numbers)
    button: "3.42rem",        // 54.72px - button/icon standard size
    buttonLg: "3.71rem",      // 59.36px - larger button/image size  
    timelineShort: "26.78rem", // 428.48px - shorter timeline connector
    timelineLong: "53.57rem",  // 857.12px - longer timeline connector
    ticketPadding: "1.875rem", // 30px - ticket component padding
    ticketGap: "2.94rem",      // 47px - ticket component gap
    circleSize: "1.75rem",     // 28px - decorative circles
  }
};

